import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';

//import tinycolor from 'tinycolor2';

import { UserSettingDto } from 'src/app/api';
import { CerSessionService } from 'src/cer/cer-session/cer-session.service';

export type CerColorTheme = 'device-default' | 'dark' | 'light';

export interface Color {
  name: string;
  hex: string;
  darkContrast: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class CerAppThemeService implements OnDestroy {
  private subscriptionManager$: Subscription = new Subscription();
  public activeThemeIcon$: BehaviorSubject<string> = new BehaviorSubject<string>('');

  constructor(session: CerSessionService) {
    this.subscriptionManager$.add(
      session.settings$.subscribe(settings => this.setupSettings(settings))
    );

    this.initTheme();
    CerUserThemeHelper.darkModeMql.addEventListener("change", e => {
      this.initTheme();
    });
  }

  public ngOnDestroy(): void {
    CerUserThemeHelper.darkModeMql.removeEventListener("change", e => CerUserThemeHelper.initTheme());
  }

  public initTheme() {
    CerUserThemeHelper.initTheme();
    this.activeThemeIconNext();
  }

  public selectTheme(theme: CerColorTheme) {
    CerUserThemeHelper.selectTheme(theme);
    this.activeThemeIconNext();
  }

  private activeThemeIconNext() {
    const icon = CerUserThemeHelper.activeIcon();
    if (icon != this.activeThemeIcon$.getValue()) {
      this.activeThemeIcon$.next(icon);
    }
  }

  private setupSettings(setup: UserSettingDto) {
    if (setup?.settings) {
      this.updatePrimaryColor(setup.settings['PrimaryColor']);
      this.updateAccentColor(setup.settings['AccentColor']);
    }
  }

  public updatePrimaryColor(primaryColorHex: string) {
    if (primaryColorHex && primaryColorHex.length > 0) {
      //      updateTheme(computeColors(primaryColorHex), 'primary');
    }
  }

  public updateAccentColor(accentColorHex: string) {
    if (accentColorHex && accentColorHex.length > 0) {
      //      updateTheme(computeColors(accentColorHex), 'accent');
    }
  }
}

export class CerUserThemeHelper {

  public static darkModeMql = window.matchMedia("(prefers-color-scheme: dark)");
  public static documentThemeAttribute = "data-theme";

  private static isDarkModeMediaQuery(): boolean {
    const darkModeMql = window.matchMedia && CerUserThemeHelper.darkModeMql;
    return darkModeMql?.matches == true;
  }

  public static activeIcon(): string {
    return CerUserThemeHelper.getStorage() == 'dark' ? 'dark_mode' : 'light_mode';
  }

  public static selectTheme(theme: CerColorTheme) {
    CerUserThemeHelper.saveStorage(theme);
    CerUserThemeHelper.activateTheme(theme);
  }

  public static activeTheme(): CerColorTheme {
    const theme = CerUserThemeHelper.getStorage();
    return CerUserThemeHelper.getThemeEffective(theme);
  }

  public static initTheme() {
    const theme = CerUserThemeHelper.getStorage();
    CerUserThemeHelper.activateTheme(theme);
  }

  private static activateTheme(theme: CerColorTheme) {
    const effectiveTheme = CerUserThemeHelper.getThemeEffective(theme);
    document.documentElement.setAttribute(CerUserThemeHelper.documentThemeAttribute, effectiveTheme);
  }

  private static ThemeKey = 'CerUserTheme';
  private static saveStorage(theme: string) {
    localStorage.setItem(CerUserThemeHelper.ThemeKey, theme);
  }

  private static getStorage(): CerColorTheme {
    const savedTheme = localStorage.getItem(CerUserThemeHelper.ThemeKey) as CerColorTheme;
    return CerUserThemeHelper.getThemeEffective(savedTheme);
  }

  private static getThemeEffective(selectedTheme: CerColorTheme): CerColorTheme {
    switch (selectedTheme) {
      case 'dark':
        return selectedTheme;
      case 'light':
        return selectedTheme;
      default:
        return CerUserThemeHelper.isDarkModeMediaQuery() ? 'dark' : 'light';
    }
  }
}


/*
function updateTheme(colors: Color[], theme: string) {
  //  console.log(document.documentElement.style.getPropertyValue(`--theme-${theme}-${colors[0].name}`));
  colors.forEach(color => {
    document.documentElement.style.setProperty(
      `--theme-${theme}-${color.name}`,
      color.hex
    );
    document.documentElement.style.setProperty(
      `--theme-${theme}-contrast-${color.name}`,
      color.darkContrast ? 'rgba(black, 0.87)' : 'white'
    );
  });
}
*/

/*
function computeColors(hex: string): Color[] {
  return [
    getColorObject(tinycolor(hex).lighten(52), '50'),
    getColorObject(tinycolor(hex).lighten(37), '100'),
    getColorObject(tinycolor(hex).lighten(26), '200'),
    getColorObject(tinycolor(hex).lighten(12), '300'),
    getColorObject(tinycolor(hex).lighten(6), '400'),
    getColorObject(tinycolor(hex), '500'),
    getColorObject(tinycolor(hex).darken(6), '600'),
    getColorObject(tinycolor(hex).darken(12), '700'),
    getColorObject(tinycolor(hex).darken(18), '800'),
    getColorObject(tinycolor(hex).darken(24), '900'),
    getColorObject(tinycolor(hex).lighten(50).saturate(30), 'A100'),
    getColorObject(tinycolor(hex).lighten(30).saturate(30), 'A200'),
    getColorObject(tinycolor(hex).lighten(10).saturate(15), 'A400'),
    getColorObject(tinycolor(hex).lighten(5).saturate(5), 'A700')
  ];
}

function getColorObject(value: any, name: string): Color {
  const c = tinycolor(value);
  return {
    name: name,
    hex: c.toHexString(),
    darkContrast: c.isLight()
  };
}
*/
